'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.Grid.Renderers', dependencies).factory('CellLinkRendererFactory', require('./factories/CellLinkRendererFactory')).factory('DiscontinuedRoutesRendererFactory', require('./factories/DiscontinuedRoutesRendererFactory'));